import * as actions from "../actionNames/translations"

const translations = (state = { data: [] }, action) => {
  switch (action.type) {
    case actions.TRANSLATIONS_ADD:
      state.data.push(action.data)
      return state
    case actions.TRANSLATIONS_EDIT:
      let changedItem = state.data.findIndex(
        (item) => item.id === action.data.id
      )
      state.data[changedItem] = action.data
      return state
    case actions.TRANSLATIONS_REMOVE:
      state.data = state.data.filter((item) => item.id !== action.data)
      return state
    case actions.TRANSLATIONS_SET:
      return { ...state, data: action.data }
    case actions.TRANSLATIONS_STATUS:
      return { ...state, status: action.status }
    default:
      return state
  }
}

export default translations
